<template>
  <v-dialog v-model="visible" persistent :max-width="width">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <span style="color: red">請用逗號(,)分隔. ex.K801,K802</span>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea v-model="typeList" placeholder="範例：K801,K802"></v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" dark text @click="cancelEvent">取消</v-btn>
        <v-btn color="primary" dark text @click="confirmEvent">確定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import common from '@/mixins/common';
import { mapActions } from 'vuex';

export default {
name: "ProductTypeDialog",
  props: {
    visible: Boolean,
    title: String,
  },
  mixins: [common],
  data() {
    return {
      width: this.isMobile ? "80%" : "50%",
      typeList:'',
    };
  },
  watch: {
    visible(value) {
      if (value === true) {
        this.loadData();
      }
    }
  },
  methods: {
    ...mapActions([
      "getProductType",
      "createProductType",
    ]),
    async loadData() {
      const res = await this.getProductType();
      const list = res.data.data;
      this.typeList = '';
      let i = 0;
      for (let item of list){
        this.typeList += i < list.length-1 ? `${item.name},` : item.name;
        i+=1;
      }
    },
    async saveData() {
      const res = await this.createProductType({
        typeList: this.typeList
      });
      const result = res.data;
      console.log(`createProductType == ${JSON.stringify(result)}`);
      if (result.statusCode === 0){

      }
    },
    async confirmEvent() {
      await this.saveData();
      this.$emit("confirmEvent");
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ProductTypeDialog.vue